<template>
	<label :class="['input-text', ver ? `input-text--${ver}` : '']">
		<span class="input-text__text--prev" v-if="prevLabel">{{
			prevLabel
		}}</span>
		<input
			:class="['input-text__input', inputClass]"
			type="text"
			ref="InputText"
			:style="inputStyle"
			@keypress="keypress"
			@input="input"
			@blur="blur"
			:value="parsingValue"
			:placeholder="placeholder"
			:disabled="disabled"
			@keydown.enter="$emit('enter')"
		/>
		<span class="input-text__text--next" v-if="nextLabel">{{
			nextLabel
		}}</span>
	</label>
</template>

<script>
	import util from '@/util.js';
	import moment from 'moment';

	export default {
		name: 'InputText',
		props: {
			inputClass: {
				type: String,
			},
			dateType: {
				type: String,
			},
			disabled: {
				default: false,
			},
			comma: {
				default: false,
			},
			mode: {
				default: false,
			},
			inputWidth: {
				type: Number,
				default() {
					return this.mode === 'date' ? 120 : 58;
				},
			},
			inputWidthUnit: {
				type: String,
				default: 'px',
			},
			prevLabel: String,
			nextLabel: String,
			useMinus: {
				type: Boolean,
				default: false,
			},
			propValue: {
				type: [String, Number, Object],
				default: '',
			},
			placeholder: String,
			ver: {
				type: String,
				default: null,
			},
		},
		data() {
			return {
				value: this.propValue,
			};
		},
		methods: {
			init() {
				this.$refs.InputText.value = '';
			},
			getValue() {
				const mode = this.mode;
				if (mode === 'number') {
					if (this.value === '') return null;
					return Number(this.value);
				} else {
					return this.value;
				}
			},
			keypress(e) {
				const mode = this.mode;
				if (mode === 'number' || mode === 'date') {
					const keyCode = e.keyCode;
					if (keyCode !== 45 && (keyCode < 48 || keyCode > 57)) {
						if (keyCode === 13) {
							this.emit('enter', e.target.value);
						} else {
							e.returnValue = false;
						}
					}
				} else if (mode === 'numberComma') {
					const keyCode = e.keyCode;
					if (
						keyCode !== 44 &&
						keyCode !== 45 &&
						(keyCode < 48 || keyCode > 57)
					)
						e.returnValue = false;
				}
			},
			parseToNumber(value) {
				const matchedValue = value.match(/\d+/g);
				const numberValue = Array.isArray(matchedValue)
					? matchedValue.join('')
					: '';
				const minus =
					this.useMinus && value.indexOf('-') > -1 ? '-' : '';
				return `${minus}${numberValue}`;
			},
			parseToNumberComma(value) {
				const matchedValue = value.match(/(\d+)|(,+)/g);
				const numberValue = Array.isArray(matchedValue)
					? matchedValue.join('')
					: '';
				const minus =
					this.useMinus && value.indexOf('-') > -1 ? '-' : '';
				return `${minus}${numberValue}`;
			},
			emit(type, value) {
				if (
					this.mode === 'month' ||
					this.mode === 'date' ||
					this.mode === 'hour' ||
					this.mode === 'minute'
				) {
					const numberValue = Number(value);
					const length = value.length;
					if (!value) value = null;
					else {
						const newDate = moment(
							value,
							'YYYYMMDDHHmm'.slice(0, length)
						)._d;
						const dateType = this.dateType;
						if (length <= 12)
							newDate.setSeconds(dateType === 'from' ? 0 : 59);
						if (length <= 10)
							newDate.setMinutes(dateType === 'from' ? 0 : 59);
						if (length <= 8)
							newDate.setHours(dateType === 'from' ? 0 : 23);
						if (length <= 6) {
							newDate.setDate(1);
							if (dateType === 'to') {
								newDate.setMonth(newDate.getMonth() + 1);
								newDate.setDate(0);
							}
						}
						if (length <= 4)
							newDate.setMonth(dateType === 'from' ? 0 : 11);
						value = isNaN(newDate.getTime()) ? null : newDate;
					}
				}
				this.$emit(type, value);
			},
			parseByType(e) {
				const getDateFormat = (numberValue, e) => {
					if (numberValue.length > 12)
						e.target.value = numberValue.replace(
							/(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})/g,
							'$1-$2-$3 $4:$5'
						);
					else if (numberValue.length > 10)
						e.target.value = numberValue.replace(
							/(\d{4})(\d{2})(\d{2})(\d{2})(\d+)/g,
							'$1-$2-$3 $4:$5'
						);
					else if (numberValue.length > 8)
						e.target.value = numberValue.replace(
							/(\d{4})(\d{2})(\d{2})(\d+)/g,
							'$1-$2-$3 $4'
						);
					else if (numberValue.length > 6)
						e.target.value = numberValue.replace(
							/(\d{4})(\d{2})(\d+)/g,
							'$1-$2-$3'
						);
					else if (numberValue.length > 4)
						e.target.value = numberValue.replace(
							/(\d{4})(\d+)/g,
							'$1-$2'
						);
					else e.target.value = numberValue;
					return numberValue;
				};
				const value = e.target.value;
				switch (this.mode) {
					case 'number':
						if (typeof value !== 'number')
							e.target.value = this.parseToNumber(value);
						break;
					case 'numberComma':
						if (typeof value !== 'number')
							e.target.value = this.parseToNumberComma(value);
						break;
					case 'month':
						return getDateFormat(
							this.parseToNumber(value).slice(0, 6),
							e
						);
					case 'date':
						return getDateFormat(
							this.parseToNumber(value).slice(0, 8),
							e
						);
					case 'hour':
						return getDateFormat(
							this.parseToNumber(value).slice(0, 10),
							e
						);
					case 'minute':
						return getDateFormat(
							this.parseToNumber(value).slice(0, 12),
							e
						);
					default:
						if (value === null) e.target.value = value;
						break;
				}
				return e.target.value;
			},
			input(e) {
				this.emit('input', this.parseByType(e));
				this.value = e.target.value;
			},
			blur(e) {
				this.emit('blur', this.parseByType(e));
			},
		},
		computed: {
			inputStyle() {
				return {
					width: `${this.inputWidth}${this.inputWidthUnit}`,
				};
			},
			parsingValue() {
				const value = this.value;
				let parsedValue = value;
				if (this.mode === 'number' && this.comma) {
					parsedValue = util.currency(value);
				}
				return parsedValue;
			},
		},
		watch: {
			propValue(newVal) {
				const mode = this.mode;
				if (newVal === null) {
					this.value = newVal;
				} else if (mode === 'number' && typeof newVal !== 'number') {
					this.value = this.parseToNumber(newVal);
				} else {
					this.value = newVal;
				}
				this.emit('input', this.value);
			},
		},
	};
</script>

<style lang="scss" scoped>
	LABEL.input-text {
		display: inline-block;
		font-size: 0;
		font-weight: 400;

		.input-text__text {
			display: inline-block;
			vertical-align: middle;
			font-size: 0.875rem;
		}

		.input-text__text--prev {
			@extend .input-text__text;
			margin: 0 8px 0 0;
		}

		.input-text__text--next {
			@extend .input-text__text;
			margin: 0 0 0 8px;
		}

		.input-text__input {
			display: inline-block;
			vertical-align: middle;
			font-size: 0.875rem;
		}

		&--3 {
			display: flex;
			height: 36px;
			flex-shrink: 0;

			.input-text__text--prev {
				display: block;
				height: 100%;
				background: lightblue;
				margin: 0;
				padding: 0 12px;
				line-height: 36px;
			}

			.input-text__input {
				display: block;
				border-radius: 0 !important;
				border-color: lightblue !important;
				border-left: 0 !important;

				&:focus {
					outline: solid 1px #0099fa !important;
				}
			}
		}
	}
</style>
